module.exports = __webpack_public_path__ + "static/media/de-raat.1fa035bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/de-raat.jpg
// module id = 1313
// module chunks = 0